import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { Button } from '..';
import { TProps } from '../types/TProps';

export const OutlinedButton = forwardRef<HTMLButtonElement, TProps>(({ className, ...props }, ref) => (
  <Button ref={ref} className={['btn--outlined', className].filter(Boolean).join(' ')} {...props} />
));

OutlinedButton.displayName = 'OutlinedButton';

export const OutlinedLink = forwardRef<HTMLAnchorElement, LinkProps>(({ className, ...props }, ref) => (
  <Link ref={ref} className={['btn btn--outlined', className].filter(Boolean).join(' ')} {...props} />
));

OutlinedLink.displayName = 'OutlinedLink';
